import React from 'react';

function Hero() {
  return (
    <div className="container py-4 py-md-5 mb-4 mb-md-5">
      <div className="row text-center">

        {/* Image */}
        <div className="col-12">
          <img
            src="media/homeHero.png"
            alt="Hero"
            className="img-fluid mb-4"
          />
        </div>

        {/* Heading */}
        <div className="col-12">
          <h1 className="mt-3 mt-md-4 px-2">
            Invest in Your Future with Our Stock Trading Platform
          </h1>
        </div>

        {/* Paragraph */}
        <div className="col-12">
          <p className="px-2">
            Online Platform to invest in stocks, derivatives, and more.
            Open an account today and start building your financial future with us.
          </p>
        </div>

        {/* Button */}
        <div className="col-12">
          <a
            href="/signup"
            className="btn btn-primary fs-5 px-4 py-2 mt-3"
          >
            Sign Up Today!
          </a>
        </div>

      </div>
    </div>
  );
}

export default Hero;